import { isArray } from 'lodash';
import { nonFacetSearchParams } from './nonFacetSearchParams';
import { findFacetByFieldName, getFacetParamKey } from './findFacet';
import { showAllQuery } from '../../../context/DataContext';

const getSearchEngineKey = (fieldName) => {
  const paramConfig = nonFacetSearchParams.find((param) => param.paramKey === fieldName);
  if (!paramConfig) {
    return null;
  }
  return paramConfig.searchEngineParamKey;
};

const isNonFacetParam = (fieldName) => {
  return !!nonFacetSearchParams.find((param) => param.paramKey === fieldName);
};

/*
 * - Serialise Formik values to URL search params
 * - Transform URL search param keys and values to be compatible with
 *   Funnelback search engine
 */
const composeFormURLSearchParams = (formValues, facets) => {
  const searchEngineParams = new URLSearchParams();

  Object.keys(formValues).forEach((fieldName) => {
    const fieldValue = formValues[fieldName];
    const isNonFacetField = isNonFacetParam(fieldName);

    if (isNonFacetField) {
      // Set non-facet search param
      const searchEngineKey = getSearchEngineKey(fieldName);
      if (searchEngineKey) {
        const paramValue = String(fieldValue)?.trim();
        if (searchEngineKey === 'query' && !paramValue) {
          searchEngineParams.set(searchEngineKey, showAllQuery);
        } else {
          searchEngineParams.set(searchEngineKey, paramValue);
        }
      }
    } else {
      // Set facet search param
      const facet = findFacetByFieldName(fieldName, facets);
      if (!facet) {
        /*
         * No matching facet found: continue
         * to process next form field.
         */
        return;
      }

      const { selectionType } = facet;
      const facetParamKey = getFacetParamKey(facet);

      const hasMultipleValues = selectionType === 'MULTIPLE';
      if (hasMultipleValues && isArray(fieldValue) && fieldValue.length) {
        fieldValue.forEach((fieldOptionValue) => {
          searchEngineParams.append(facetParamKey, fieldOptionValue);
        });
      } else {
        searchEngineParams.set(facetParamKey, fieldValue);
      }
    }
  });

  return searchEngineParams;
};

export default composeFormURLSearchParams;
